import React, { ComponentType, HTMLAttributes, useContext, useEffect } from 'react';
import { TValidatorHash } from 'core/parseValidators';
import FormContext from '../FormContext';

export interface IResultSectionProps<D = any>
  extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  /** The name of the form section to connect */
  name: string;
  /** The data initially passed into the form section */
  initialData?: D;
  /** The Validators to run on the form data. */
  validators?: TValidatorHash<D>;
  [key: string]: any;
}

const connectSectionToContext = <TProps, D = any>(Section: ComponentType<TProps>) => {
  const MemoizedSection = React.memo(Section) as unknown as ComponentType<TProps>;

  const ResultSection = (props: IResultSectionProps<D> & TProps) => {
    const {
      data: parentData = {},
      errors: parentErrors = {},
      onChange,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      resetData,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      resetErrors,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      validate,
      ...formContext
    } = useContext(FormContext);
    const { initialData, name } = props;

    const data = parentData[name];
    const errors = parentErrors[name];

    useEffect(() => {
      if (!data && initialData) {
        onChange?.(name, initialData);
      }
    }, [data, initialData, name, onChange]);

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      <MemoizedSection
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        data={data}
        errors={errors}
        onChange={onChange}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...formContext}
      />
    );
  };

  /* istanbul ignore next */
  ResultSection.displayName = `FormContext(${Section.displayName || Section.name || 'Component'})`;

  return ResultSection;
};

export default connectSectionToContext;
